import Component from './UIButton'

export default Component
